module.exports = __webpack_public_path__ + "static/media/greyBin.c5562327.svg";